<template lang="html">
    <div class="" style="min-width:1440px;">

        <div class="page-title-container">
            <h1 class="mb-0 p-2 display-4">
                Statistiques par consultant
            </h1>
        </div>

    <div class="columns" style="flex-grow: 1; display: flex; margin: 0px; max-height: 95%;">
        <div class="column is-3"
             style="flex-frow:unset;min-width: 450px;max-width: 450px">
            <div class="card"
                 style="overflow-x:hidden;">
                <div class="card-body pl-1">
                    <div class="search-input-container border border-separator rounded-md bg-foreground mb-2">
                        <input v-model="searchQuery"
                               class="form-control search"
                               type="text"
                               autocomplete="off"
                               placeholder="Rechercher consultant" />
                        <span class="search-magnifier-icon">
                            <svg xmlns="http://www.w3.org/2000/svg"
                                 width="20"
                                 height="20"
                                 viewBox="0 0 20 20"
                                 fill="none"
                                 stroke="currentColor"
                                 stroke-width="1.5"
                                 stroke-linecap="round"
                                 stroke-linejoin="round"
                                 class="acorn-icons acorn-icons-search undefined">
                                <circle cx="9" cy="9" r="7"></circle>
                                <path d="M14 14L17.5 17.5"></path>
                            </svg>
                        </span>
                    </div>
                    <div class="scroll">
                        <ConsultantList :searchQuery="searchQuery"
                                        v-if="$store.state.stats"></ConsultantList>
                    </div>
                </div>
            </div>

        </div>
        
        <div class="column " style="">
            <div class="row">
                <div class="card mb-3">
                    <div class="card-body p-3">
                        <div class="row"
                             v-if="consultant && consultant.avatar">
                            <div class="col-4">
                                <div class="position-relative">
                                    <img :src="backendMediaUrl + (consultant && consultant.avatar)"
                                         class="img-fluid rounded-md sh-10"
                                         alt="thumb">
                                </div>
                            </div>
                            <div class="col-8">
                                <div class="h6 mb-2"
                                     v-if="consultant && consultant.fullname">
                                    {{ consultant && consultant.fullname }}
                                </div>
                                <div class="text-muted">
                                    <a v-if="consultant && consultant.phone">
                                        <i class="bi bi-telephone"
                                           style="font-size: 15px; stroke-width: 1.5;">
                                        </i> <span>&nbsp;</span>
                                        <span>{{ consultant && consultant.phone }}</span>
                                    </a>
                                </div>
                                <div v-if="consultant && consultant.email"
                                     class="text-muted">
                                    <a>
                                        <i class="bi bi-at"
                                           style="font-size: 15px;"></i>
                                        <span>&nbsp;</span>
                                        <span>{{ consultant && consultant.email }}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card p-0">
                    <div class="card-body p-0">
                        <EstablishmentList :autoload="false"
                                           title="Établissements"
                                           style="height:calc(100vh - 210px);">
                        </EstablishmentList>
                    </div>
                </div>
            </div>
        </div>
        <div class="column" style="min-width:520px;max-width:520px;">
            <ConsultantDetail v-if="consultant && $store.state.stats"
                              :consultant_uid="$store.state.selected_consultant_uid">
            </ConsultantDetail>
            <div class="card">
                <div class="card-body p-3">
                    <ReviewList :autoload="false"
                                :consultant_uid="$store.state.selected_consultant_uid"
                                :consultant="consultant"
                                style="height:calc(100vh - 295px);">
                    </ReviewList>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import ReviewList from '@/components/ReviewList.vue';
import EstablishmentList from '@/components/EstablishmentList.vue';
import ConsultantList from '@/components/ConsultantList.vue';
import ConsultantDetail from '@/components/ConsultantDetail.vue';
import utils from '@/utils.js';
import settings from "@/settings.coffee";
import CONSULTANT_DETAIL from '@/gql/queries/consultantDetail.graphql';
import { gqlQuery } from '@/gqlClient.js';

export default {
    name: 'manage',
    data: function() {
        return {
            listHeight: (window.innerHeight - 229) + "px",
            consultant: null,
            stats: null,
            backendMediaUrl: settings.backendMediaUrl,
            searchQuery: ""
        };
    },
    components: {
        ConsultantList,
        ReviewList,
        EstablishmentList,
        ConsultantDetail
    },
    methods: {
        setHeight: utils.debounce(function() {
            this.listHeight = (window.innerHeight - 295) + "px";
        }, 500)
    },
    mounted: function() {
        this.setHeight();
        window.addEventListener('resize', this.setHeight);
    },
    beforeDestroy: function() {
        window.removeEventListener('resize', this.setHeight);
    },
    watch: {
        "$store.state.selected_consultant_uid": async function(newV, oldV) {
            if (newV && newV !== oldV) {
                const res = await gqlQuery(CONSULTANT_DETAIL, { id: newV });
                this.consultant = res.body.data.consultant || null;
            }
        }
    }
};
</script>
<style scoped>
.scroll{
    overflow-x:hidden;
    height: calc(100vh - 155px);
}
</style>
